import React from "react";
import { string, bool, any } from "prop-types";
import { Link } from "@quintype/components";

const LinkTag = ({ isExternalStory, href, children, rel = "noreferrer", ...props }) => {
  return isExternalStory ? (
    <a href={href} target="_blank" rel="nofollow" {...props}>
      {children}
    </a>
  ) : (
    <Link href={href} {...props}>
      {children}
    </Link>
  );
};

LinkTag.defaultProps = {
  isExternalStory: false,
};

LinkTag.propTypes = {
  href: string,
  rel: string,
  isExternalStory: bool,
  children: any,
};

export default LinkTag;
